import React from "react";

const WhatWeOffer = () => {
  return (
    <section className="about_us mt_100 xs_mt_70">
      <div className="container">
        <div className="section_heading mb_25 textleft">
          <h4 className="fs-2">What We Offer</h4>
          <p className="fw-bold pb-3 font-20">
            Our Menu Showcase a variety of mouthwatering dishes, including :
          </p>
          <ul className="list-group-numbered mb-3 fw-semibold">
            <li className="list-group-item  font-20">
              Succulent grilled meats infused with African spices
            </li>
            <li className="list-group-item py-2  font-20">
              Flavorful sides inspired by traditional recipes
            </li>
            <li className="list-group-item  font-20">
              House-made sauces and seasoning for an extra brust of flavor
            </li>
          </ul>
          <p className="font-20">
            Whether you're hosting a special event, grabbing takeout, or joining
            us at public events for a casual meal, Afrikan BBQ LLC promises to
            provide a culinary experience that's second to none.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhatWeOffer;
